import React from 'react';
import * as colors from '../../common/colorConstants';
import SimplrLogo from '../../common/SimplrLogo';
import * as S from './AuthLayout.styles';

const AuthLayout = ({ children }) => {
  return (
    <S.Wrapper>
      <S.Background>
        <S.SimplrLogoMobileWrapper>
          <SimplrLogo color={colors.darkGray14} />
        </S.SimplrLogoMobileWrapper>
        <div>
          <S.SimplrLogoWrapper>
            <SimplrLogo color={colors.electricBlue} />
          </S.SimplrLogoWrapper>
          <>
            <S.HeaderText>
              <S.Divider space="52px" />
              <S.Heading>
                Work Anytime,
                <br />
                Anywhere.
              </S.Heading>
            </S.HeaderText>
          </>
        </div>
        <S.SimplrImage />
        <S.MobileHeaderText>Expert Dashboard</S.MobileHeaderText>
      </S.Background>

      <S.Main>{children}</S.Main>
    </S.Wrapper>
  );
};

export default AuthLayout;
